import { Offcanvas } from "react-bootstrap";
import { FaFilter, FaTimes } from "react-icons/fa";

const FilterRequestAccess = ({ Show, Hide }) => {
  // --- Static data ---
  const STATUSES = [
    "Submitted",
    "Under Review",
    "More Info Required",
    "Approved",
    "Access Granted",
    "Closed",
    "Rejected",
    "Deactivated"
  ];
  
  const STUDIES = [
    "GBX-2201",
    "GBX-2415",
    "GBX-2109"
  ];
  
  const APPLICATIONS = [
    "EDC",
    "IWRS/RTSM",
    "eTMF",
    "Safety Database",
    "CDISC/Programming Portal",
    "LUP (Lab Upload Portal)",
    "Training Management System"
  ];

  return (
    <Offcanvas
      show={Show}
      onHide={Hide}
      placement="end"
      style={{ width: "420px" }}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          <FaFilter className="me-2" /> Filter Requests
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        {/* --- Status --- */}
        <div className="mb-2">
          <label className="mb-1 fw-bold" style={{ fontSize: 13.5 }}>
            Status
          </label>
          <select className="form-select form-select-sm">
            <option value="">All statuses</option>
            {STATUSES.map((status) => (
              <option key={status}>{status}</option>
            ))}
          </select>
        </div>

        {/* --- Study --- */}
        <div className="mb-2">
          <label className="mb-1 fw-bold" style={{ fontSize: 13.5 }}>
            Study
          </label>
          <select className="form-select form-select-sm">
            <option value="">All studies</option>
            {STUDIES.map((study) => (
              <option key={study}>{study}</option>
            ))}
          </select>
        </div>

        {/* --- Application --- */}
        <div className="mb-2">
          <label className="mb-1 fw-bold" style={{ fontSize: 13.5 }}>
            Application
          </label>
          <select className="form-select form-select-sm">
            <option value="">All applications</option>
            {APPLICATIONS.map((app) => (
              <option key={app}>{app}</option>
            ))}
          </select>
        </div>

        {/* --- Submitted From --- */}
        <div className="mb-2">
          <label className="mb-1 fw-bold" style={{ fontSize: 13.5 }}>
            Submitted from
          </label>
          <input
            type="date"
            className="form-control form-control-sm"
            style={{ fontSize: 14 }}
          />
        </div>

        {/* --- Submitted To --- */}
        <div className="mb-0">
          <label className="mb-1 fw-bold" style={{ fontSize: 13.5 }}>
            Submitted to
          </label>
          <input
            type="date"
            className="form-control form-control-sm"
            style={{ fontSize: 14 }}
          />
        </div>
      </Offcanvas.Body>

      <div className="text-end p-2 border-top d-flex gap-2 justify-content-end">
        <button className="removeProfile">
          <FaTimes className="me-1" /> Clear All
        </button>
        <button className="updateProfile">
          <FaFilter className="me-1" /> Apply Filters
        </button>
      </div>
    </Offcanvas>
  );
};

export default FilterRequestAccess;